import { Tag } from "common/components/Tag"
import { Mic } from "lucide-react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"

export const AudioTag = () => {
  const t = useTranslations("components.content_summary_tag")
  return <Tag icon={<Mic className="size-3.5" />}>{t("listen")}</Tag>
}
